module.exports = "/_next/static/images/stripe6-ca690adffa5ab123650d1c2ca694964e.png";